 
import React, { useEffect, useState, useCallback, useMemo } from "react";
import ApiSession from "../api/ApiSession";
import embLabels from "../config/emb-labels-en.json";
import {
  validateFortigateConfiguration,
  validateMoxaConfiguration,
} from "../utils/secureArchitectureValidation";
import SecureTableHeading from "./SecureArchitecture/SecureTableHeading";
import SecureCommunicationTable from "./SecureArchitecture/SecureCommunicationTable";
import MoxaCommunicationTable from "./SecureArchitecture/MoxaCommunicationTable";
import { withRouter } from "react-router-dom";
import FortigatePortVlanTable from "./SecureArchitecture/FortigatePortVlanTable";
import FortigateConnexiumVlanTable from "./SecureArchitecture/FortigateConnexiumVlanTable";
import VlanTableHeading from "./SecureArchitecture/VlanTableHeading";
import { fortiGateVlanHeaders, moxaVlanHeaders } from "../utils/constants";
import { projectAtomList } from "../atoms";
import { useAtom } from "jotai";
import useProjectTypeValue from "../utils/useCurrentProjectValue";
const apiSession = new ApiSession();
 
const SecureArchitectureHook = (props) => {
  let userSampleData = {
    name: "",
    role: "",
    access: "",
  };
  const projectTypeValue = useProjectTypeValue();
 
  let userScope;
  try {
    const stored = JSON.parse(localStorage.getItem("scope"));
    userScope = stored !== null ? stored : userSampleData;
  } catch (e) {
    userScope = userSampleData;
  }
  const [UserScope] = useState(userScope);
  const [loading, setLoading] = useState(false);
  const { projectId: urlProject } = props.match.params;
  const [snackBar, setSnackBar] = useState({ type: "", message: "" });
  const [currentProject, setCurrentProject] = useAtom(projectAtomList);
  const [secureCommunicationData, setSecureCommunicationData] = useState();
 const [hasConflicts, setHasConflicts] = useState([]);
 const [fortigateConfigValidity,setFortigateConfigValidity] = useState(false);
  const [vlanConfiguration, setVlanConfiguration] = useState("");
  const [memberTypeList, setMemberTypeList] = useState(["ACCESS","HYBRID_TRUNK"]);
  const [interfaceTypeListFortigate, setInterfaceTypeListFortigate] = useState(["VLAN_SWITCH","LAN","WAN"]);
  const [interfaceTypeListFortigateConexium, setInterfaceTypeListFortigateConexium] = useState(["VLAN","TRUNK"]);
  const [wanSelected, setWanSelected] = useState(false);
  // Track taken VLAN accessMembers for VLAN_SWITCH ports as a Set
  const [vlanSwitchTakenAccessMembers, setVlanSwitchTakenAccessMembers] = useState(new Set());
  const [copyOfdropwonValues, setCopyOfDropwonValues] = useState(null);
  // Compute which access member VLANs across all fortigate ports conflict with trunk members (hasConflicts)
  const accessVlansInConflict = useMemo(() => {
    if (!hasConflicts || hasConflicts.length === 0) return [];
    const configs = secureCommunicationData?.fortigateVlanConfigurations || [];
    const conflicting = new Set();
    configs.forEach(config => {
      const accessVlan = config?.accessMembers?.vlan;
      if (accessVlan && hasConflicts.includes(accessVlan)) {
        conflicting.add(accessVlan);
      }
    });
    return Array.from(conflicting);
  }, [secureCommunicationData?.fortigateVlanConfigurations, hasConflicts]);
 useEffect(()=>{
  if(props?.secureArchitectureData){
     const hasWAN  = props?.secureArchitectureData?.fortigateVlanConfigurations?.some(item => item.memberType === "WAN");
    setWanSelected(hasWAN);
  }
  setSecureCommunicationData(props.secureArchitectureData);
  setVlanConfiguration(props.secureArchitectureData?.gatewayType);
 },[props.secureArchitectureData])
 // Initialize hasConflicts with existing trunk members on data load
  useEffect(() => {
    if (secureCommunicationData?.fortigateVlanConfigurations) {
      const allTrunkMembers = new Set();
      secureCommunicationData.fortigateVlanConfigurations.forEach(config => {
        if (config?.hybridMembers && Array.isArray(config?.hybridMembers)) {
          config?.hybridMembers?.forEach(member => {
            if (member?.vlan) {
              allTrunkMembers.add(member?.vlan);
            }
          });
        }
      });
      setHasConflicts(Array.from(allTrunkMembers));
    }
  }, [secureCommunicationData]);
 
  useEffect(() => {
    const connexiumConfigs = secureCommunicationData?.connexiumFortigateVlanConfigurations || [];
    // Only VLAN-type ports need to have access members from the trunk members list
    // TRUNK ports are exempt from this validation
    const hasAtLeastOneInvalidSelection = connexiumConfigs.some((config) => {
      if (config.memberType === "TRUNK") return false;
      const selectedAccessMember = config?.accessMembers?.vlan;
      return !hasConflicts.includes(selectedAccessMember);
    });
    setFortigateConfigValidity(hasAtLeastOneInvalidSelection);
  }, [secureCommunicationData, hasConflicts]);
  useEffect(() => {
    const projectId = props && props?.projectId
    if (!projectId) {
      let { history } = props;
      history?.push({
        pathname: `${"/information"}/${projectId}`,
      });
    }
  }, []);
 
  const saveSecureCommunicationData = () => {
    if(vlanConfiguration ==="") {
      callSnackbar("error","Please select configuration type before saving.");
      return;
    }
 
    // Validate fortigate configuration using extracted utility
    if(vlanConfiguration === "fortigate") {
      const error = validateFortigateConfiguration(secureCommunicationData, hasConflicts);
      if (error) {
        callSnackbar("error", error);
        return;
      }
    }
 
    // Validate moxa configuration using extracted utility
    if(vlanConfiguration === "moxa") {
      const error = validateMoxaConfiguration(secureCommunicationData);
      if (error) {
        callSnackbar("error", error);
        return;
      }
    }
 
    setLoading(true);
    const secureArchitectureDataJSON = {
      ...secureCommunicationData,
      gatewayType:vlanConfiguration,
      systemsPage:false,
      secureArchitecturePage:true,
    }
    apiSession
      .upDataSecureArchitectureData(secureArchitectureDataJSON)
      .then((response) => {
        if(response){
          setSecureCommunicationData(response);
          props?.setSecureArchitectureData?.(response);
          setLoading(false);
           if (urlProject) {
          apiSession
            .getProject(urlProject)
            .then((json) => {
              if(json){
                 setCurrentProject((prevData) => ({
                ...prevData,
                project: json,
                timeSettingsValidated: json?.systemsTimeSyncPage,
                showAsset: json?.projectId,
                showUseCase: json?.deploymentReady,
                showSystems: !json?.programPage,
                showBOM:
                  json.systemsPage === false &&
                  json?.secureArchitecturePage === true &&
                  json.systemsTimeSyncPage === true &&
                  !json?.programPage,
                showDeploy:
                  json.systemsPage === false &&
                  json?.secureArchitecturePage === true &&
                  json.systemsTimeSyncPage === true &&
                  !json?.programPage,
              }));
             
              sessionStorage.setItem("pType", json?.projectTypeDisplayValue);
              sessionStorage.setItem("pname", json?.projectTypeDisplayValue);
              sessionStorage.setItem("projectId", json?.projectId);
              sessionStorage.setItem("projectKindType", json?.projectType);
              sessionStorage.setItem("deploymentReady", json?.deploymentReady);
              sessionStorage.setItem(
                "projectType",
                JSON.stringify({ projectTypeValue: json?.projectType })
              );
              if (json.systemsPage) {
                setRedirectAlert((prev) => ({
                  message: shellLayoutConst.VALIDATE_SYSTEMS_ALERT,
                  alertPopUpStatus: true,
                  title: "ALERT",
                  isRoute: true,
                  routePath: `/systems/${urlProject}`,
                }));
              }
            }
            })
            .catch((error) => {
              if (error?.status === 404) {
                setRedirectAlert((prev) => ({
                  message: shellLayoutConst.VALIDATE_SYSTEMS_ALERT,
                  alertPopUpStatus: true,
                  title: "ALERT",
                  isRoute: true,
                  routePath: `/systems`,
                }));
              }
            });
        }
          const isSystemPageValidated = sessionStorage.getItem("communicationValidated") === "false";
          const isTimeSyncValidated = props?.timeSyncData?.timeServerEntity !== null && props?.timeSyncData?.timeServerEntity !== undefined;
 
          if (isSystemPageValidated && isTimeSyncValidated) {
            let { history } = props;
            history.push({
              pathname: `/bom/${props.projectId}`,
            });
          }else if(!isSystemPageValidated ){
            props?.setKey("system");
          }
           else if (!isTimeSyncValidated) {
            props?.setKey("time");
          } else {
            props?.setKey("system");
          }
        }
       
        callSnackbar(
          "success",
          "Secure communication settings updated successfully"
        );
      })
      .catch((error) => {
        setLoading(false);
        callSnackbar(
          "error",
          "Failed to update secure communication settings. Please try again."
        );
      });
  };
  const computeVlanSwitchTakenAccessMembers = useCallback((overridePort = null, overrideVlan = null, overrideConfigs = null) => {
    // Prefer latest state (secureCommunicationData) over props after initial load.
    // Allow caller to pass freshly updated configuration array via overrideConfigs for accuracy.
    const source = overrideConfigs
      ? overrideConfigs
      : (secureCommunicationData?.fortigateVlanConfigurations || []);
    const takenSet = new Set();
    source.forEach(item => {
      if (item?.memberType === "VLAN_SWITCH") {
        const vlanVal = (overridePort && overrideVlan && item.port === overridePort)
          ? overrideVlan
          : item?.accessMembers?.vlan;
        if (vlanVal) takenSet.add(vlanVal);
      }
    });
    setVlanSwitchTakenAccessMembers(takenSet);
    return takenSet;
  }, [secureCommunicationData]);
 
  const handleSelectMemberType = (member, port, type) => {
    // Pre-build a lookup map for securedCommunicationArchitecture VLANs (for MGMT default)
    const vlanLookup = new Map(
      (secureCommunicationData?.securedCommunicationArchitecture || []).map(item => [item.vlan, item])
    );
 
    // Collect existing fortigate trunk hybridMembers so we can copy them to Connexium TRUNK ports
    const fortigateTrunkHybridMembers = (() => {
      const fortigateConfigs = secureCommunicationData?.fortigateVlanConfigurations || [];
      for (const cfg of fortigateConfigs) {
        if (cfg.hybridMembers && cfg.hybridMembers.length > 0) {
          return cfg.hybridMembers;
        }
      }
      return [];
    })();
 
    const updatedMoxaMemberTypeConfigurations = secureCommunicationData?.[type]?.map((config) => {
      if (port === config.port) {
        // If selecting VLAN_SWITCH ensure default accessMembers points to MGMT VLAN definition
        if (member === "VLAN_SWITCH") {
          const mgmtAccessMember = vlanLookup.get("MGMT") || config.accessMembers;
          return {
            ...config,
            memberType: member,
            accessMembers: mgmtAccessMember,
          };
        }
        if (["HYBRID_TRUNK", "TRUNK"].includes(member)) {
          // When switching a Connexium port to TRUNK, populate hybridMembers from fortigate trunk selections
          const shouldCopyFromFortigate =
            type === 'connexiumFortigateVlanConfigurations' &&
            member === 'TRUNK' &&
            (!config.hybridMembers || config.hybridMembers.length === 0);
          // When switching to TRUNK on Connexium, also default accessMembers to MGMT
          const shouldDefaultToMgmt =
            type === 'connexiumFortigateVlanConfigurations' && member === 'TRUNK';
          const mgmtAccessMember = shouldDefaultToMgmt
            ? (vlanLookup.get("MGMT") || config.accessMembers)
            : config.accessMembers;
          return {
            ...config,
            memberType: member,
            accessMembers: mgmtAccessMember,
            hybridMembers: shouldCopyFromFortigate
              ? [...fortigateTrunkHybridMembers]
              : (config.hybridMembers || []),
          };
        }
        // All other member types reset hybridMembers array
        return {
          ...config,
          memberType: member,
          hybridMembers: [],
        };
      }
      return config;
    }) || [];
    const hasWAN  = updatedMoxaMemberTypeConfigurations.some(item => item.memberType === "WAN");
    setWanSelected(hasWAN);
    setSecureCommunicationData(prev =>( {
      ...prev,
      [type]: updatedMoxaMemberTypeConfigurations,
    }));
    // Recompute taken VLANs using updated array to avoid stale props
    if(type === 'fortigateVlanConfigurations') {
      computeVlanSwitchTakenAccessMembers(null, null, updatedMoxaMemberTypeConfigurations);
    } else {
      computeVlanSwitchTakenAccessMembers();
    }
  };
   
  const handleAccessEnable = (e, port, type) => {
    const updatedMoxaEnableConfigurations = secureCommunicationData?.[type]?.map(
      (config) => {
        if (port === config.port) {
          return {
            ...config,
            enable: e,
          };
        }
        return config;
      }
    );
 
    setSecureCommunicationData(prev =>({
      ...prev,
      [type]: updatedMoxaEnableConfigurations,
    }));
  };
   
  const handleSelectAccessMember = (event, port, type) => {
    const updatedAccessMemberConfigurations = secureCommunicationData[
      type
    ]?.map((config) => {
      let accessMember = { ...config.accessMembers };
      if (port === config.port) {
        let accessMem =
        secureCommunicationData?.securedCommunicationArchitecture;
        const filterMember = accessMem?.filter(
          (data) => data.vlan === event.target.value
        );
        accessMember = filterMember[0];
 
        return {
          ...config,
          ["accessMembers"]: accessMember,
        };
      } else {
        return {
          ...config,
          ["accessMembers"]: accessMember,
        };
      }
    });
    setSecureCommunicationData(prev=>({
      ...prev,
      [type]: updatedAccessMemberConfigurations,
    }));
    // Recompute taken VLANs after access member change using override & updated configs
    if(type === 'fortigateVlanConfigurations') {
      computeVlanSwitchTakenAccessMembers(port, event.target.value, updatedAccessMemberConfigurations);
    } else {
      computeVlanSwitchTakenAccessMembers(port, event.target.value);
    }
  };
  // No-op: kept for child component prop compatibility
  const getHybridMembers = () => {};
  const dropdownValues = (selectedOption, portSelected, type) => {
    // Normalize selectedOption to array
    const selectedArray = Array.isArray(selectedOption) ? selectedOption : [];
    const originalConfigs = secureCommunicationData?.[type] || [];
    // Determine if selected port currently represents VLAN_SWITCH with MGMT
    const isSelectedVlanSwitchMgmt = originalConfigs.some(cfg => cfg.port === portSelected?.port && cfg.memberType === 'VLAN_SWITCH' && cfg?.accessMembers?.vlan === 'MGMT');
 
    const updatedConfigurations = originalConfigs.map(config => {
      if (portSelected?.port === config.port) {
        // Always update the selected port's hybridMembers with new selection
        return {
          ...config,
          hybridMembers: [...selectedArray],
        };
      }
      // Only clear hybridMembers for OTHER VLAN_SWITCH+MGMT ports
      if (
        config?.memberType === 'VLAN_SWITCH' &&
        config?.accessMembers?.vlan === 'MGMT' &&
        config?.port !== portSelected?.port
      ) {
        return {
          ...config,
          hybridMembers: [],
        };
      }
     
      return config;
    });
 
    setSecureCommunicationData(prev => {
      const updated = {
        ...prev,
        [type]: updatedConfigurations,
      };
 
      // If fortigate configuration was updated, also sync hybridMembers to all TRUNK ports in connexium
      if (type === 'fortigateVlanConfigurations') {
        const connexiumConfigs = prev?.connexiumFortigateVlanConfigurations || [];
        let hasTrunkPort = false;
        const updatedConnexiumConfigs = connexiumConfigs.map(config => {
          if (config.memberType === 'TRUNK') {
            hasTrunkPort = true;
            return {
              ...config,
              hybridMembers: [...selectedArray],
            };
          }
          return config;
        });
        setCopyOfDropwonValues(updatedConnexiumConfigs);
        if (hasTrunkPort) {
          updated.connexiumFortigateVlanConfigurations = updatedConnexiumConfigs;
        }
      }
 
      return updated;
    });
 
    // If fortigate configuration was updated, recompute taken access members and update conflicts
    if (type === 'fortigateVlanConfigurations') {
      computeVlanSwitchTakenAccessMembers();
      const memberList = selectedOption.map(item => item.vlan);
      setHasConflicts(memberList);
    }
  };
  const callSnackbar = (type, message) => {
    setSnackBar({ type, message });
    document.getElementById("custom-securepage").open = true;
  };
  const handleVlanConfiguration = (e) => {
    const {name, value} = e.target;
    setVlanConfiguration(value);
 
    // When switching to fortigate, recompute hasConflicts from existing trunk members
    // instead of clearing, so Connexium borders reflect the current state
    if (value === "fortigate") {
      const allTrunkMembers = new Set();
      (secureCommunicationData?.fortigateVlanConfigurations || []).forEach(config => {
        if (config.hybridMembers && Array.isArray(config.hybridMembers)) {
          config.hybridMembers.forEach(member => {
            if (member.vlan) {
              allTrunkMembers.add(member.vlan);
            }
          });
        }
      });
      setHasConflicts(Array.from(allTrunkMembers));
    } else {
      setHasConflicts([]);
    }
  }
 
  // Keep Set in sync when incoming secureArchitectureData changes (e.g., initial load)
  useEffect(() => {
    computeVlanSwitchTakenAccessMembers();
  }, [computeVlanSwitchTakenAccessMembers]);
  return (
    <>
      {loading && <se-loading loading={loading} full-page="true"></se-loading>}
      <div>
        {props?.siteType ? (
          <div>
            <div
              className={
                (props?.siteCreated && projectTypeValue !== "NMGaaS ETO")||
                props?.projectStatusData?.projectStatus === "COMPLETED" ||
                props?.projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
                  ? "se-block-disabled row"
                  : !UserScope.access.saveSystemInfo
                  ? "se-block-disabled row"
                  : "row"
              }
            >
              <div
                className="col-md-12 mt-1"
                style={
                  props?.siteType === embLabels.GENSET_PVBESS_A2E
                    ? { userSelect: "none", pointerEvents: "none" }
                    : {}
                }
              >
                {(props.siteType === embLabels.ISLANDABLE ||
                props.siteType === embLabels.OFF_GRID ||
                  props.siteType === embLabels.GRID_CONNECTED ||
                  props.siteType === embLabels.PV_HYBRIDIZATION ||
                  (props.siteType === embLabels.ISLANDABLE_GSX &&
                    props.architectureType === embLabels.PV_GENSET_ATS) ||
                  (props.siteType === embLabels.GRID_CONNECTED_GSX &&
                    props.architectureType === embLabels.PV_BESS_NR)) && (
                  <>
                   
                    <div className="row mt-2">
                      <div className="col-md-12">
                        <span className="se-font-14px-bold se-life-green">
                          {" "}
                          VLAN Subnet Definitions.
                        </span>
 
                        <div className="table-responsive mt-2">
                          <SecureTableHeading
                            data={
                              secureCommunicationData?.securedCommunicationArchitecture
                            }
                          />
                          <table className="table table-bordered ">
                            <tbody>
                              {secureCommunicationData?.securedCommunicationArchitecture?.map(
                                (data) => (
                                  <SecureCommunicationTable
                                    key={data.id}
                                    data={data}
                                  />
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
 
                    <div className="row mt-1 mb-1 ">
                      <div className="col-sm-12 se-font-14px-bold se-life-green mb-1">
                        Select Configuration Type
                      </div>
                      <div className="col-sm-2 col-md-2 col-lg-2 col-xl-2 mb-2 ">
                        <div className="custom-control custom-radio">
                          <input
                            type="radio"
                            id="vlanConfigurationMoxa"
                            name="vlanConfiguration"
                            className="custom-control-input islandableRadio  asCompatible"
                            checked={vlanConfiguration === "moxa"}
                            onClick={handleVlanConfiguration}
                            value="moxa"
                          />
                          <label
                            className="custom-control-label line-height-25px"
                            htmlFor="vlanConfiguration"
                          >
                            Moxa
                          </label>
                        </div>
                      </div>
                       <div className="col-sm-2 col-md-2 col-lg-2 col-xl-2 mb-2 ">
                        <div className="custom-control custom-radio">
                          <input
                            type="radio"
                            id="vlanConfigurationFortigate"
                            name="vlanConfiguration"
                            className="custom-control-input islandableRadio  asCompatible"
                            checked={vlanConfiguration === "fortigate"}
                            onClick={handleVlanConfiguration}
                            value="fortigate"
                          />
                          <label
                            className="custom-control-label line-height-25px"
                            htmlFor="vlanConfiguration1"
                          >
                            Fortigate
                          </label>
                        </div>
                      </div>
                    </div>
                    { vlanConfiguration === "moxa" ?
                      <>
                      <div className="row">
                        <div className="col-md-12">
                          <span className="se-font-14px-bold se-life-green">
                            {" "}
                            Moxa Port to VLAN Configuration
                          </span>
 
                          <div className="table-responsive mt-2">
                            <VlanTableHeading headers = {moxaVlanHeaders} />
                            <table className="table table-bordered">
                              <tbody>
                                {secureCommunicationData?.moxaVlanConfigurations?.map(
                                  (data) => (
                                    <MoxaCommunicationTable
                                    typeList ={memberTypeList}
                                      key={data.id}
                                      data={data}
                                      communicationType="moxaVlanConfigurations"
                                      handleSelectMemberType={
                                        handleSelectMemberType
                                      }
                                      handleAccessEnable={handleAccessEnable}
                                      handleSelectAccessMember={
                                        handleSelectAccessMember
                                      }
                                      getHybridMembers={getHybridMembers}
                                      secureData={secureCommunicationData}
                                      dropdownValues={dropdownValues}
                                    />
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                   
                      <div className="row">
                        <div className="col-md-12 ">
                          <span className="se-font-14px-bold se-life-green">
                            {" "}
                            Moxa : Connexium VLAN Configurations
                          </span>
 
                          <div className="table-responsive mt-2">
                            <VlanTableHeading headers = {moxaVlanHeaders} />
                            <table className="table table-bordered">
                              <tbody>
                                {secureCommunicationData?.connexiumVlanConfigurations?.map(
                                  (data) => (
                                    <MoxaCommunicationTable
                                   typeList = {memberTypeList}
                                      key={data.id}
                                      data={data}
                                      communicationType="connexiumVlanConfigurations"
                                      handleSelectMemberType={
                                        handleSelectMemberType
                                      }
                                      handleAccessEnable={handleAccessEnable}
                                      handleSelectAccessMember={
                                        handleSelectAccessMember
                                      }
                                      getHybridMembers={getHybridMembers}
                                      secureData={secureCommunicationData}
                                      dropdownValues={dropdownValues}
                                    />
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      </>
                      :
                       <>
                      <div className="row">
                        <div className="col-md-12">
                          <span className="se-font-14px-bold se-life-green">
                            {" "}
                            FortiGate Port to VLAN Configuration
                          </span>
                          {accessVlansInConflict.length > 0 && (
                            <span className="se-mandatory pl-4">
                              Rule: {"  "}Conflict: VLAN(s) {accessVlansInConflict.join(", ")} are assigned as trunk member(s) and also used as access member(s). Please resolve before saving.
                            </span>
                          )}
 
                          <div className="table-responsive mt-2">
                            <VlanTableHeading headers = {fortiGateVlanHeaders}/>
                            <table className="table table-bordered">
                              <tbody>
                                {secureCommunicationData?.fortigateVlanConfigurations?.map(
                                  (data) => (
                                      <FortigatePortVlanTable
                                      typeList={interfaceTypeListFortigate}
                                      key={data.id}
                                      data={data}
                                      communicationType="fortigateVlanConfigurations"
                                      handleSelectMemberType={
                                        handleSelectMemberType
                                      }
                                      handleAccessEnable={handleAccessEnable}
                                      handleSelectAccessMember={
                                        handleSelectAccessMember
                                      }
                                      getHybridMembers={getHybridMembers}
                                      secureData={secureCommunicationData}
                                      dropdownValues={dropdownValues}
                                      hasConflicts = {hasConflicts}
                                      vlanConfigurationType={vlanConfiguration}
                                      wanSelected={wanSelected}
                                      vlanSwitchTakenAccessMembers={Array.from(vlanSwitchTakenAccessMembers)}
                                      accessVlansInConflict={accessVlansInConflict}
                                    />
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                   
                      <div className="row">
                        <div className="col-md-12 ">
                          <span className="se-font-14px-bold se-life-green">
                            {" "}
                            FortiGate : Connexium VLAN Configurations  {"    "}
                          </span>
                         {(hasConflicts?.length === 0 || fortigateConfigValidity)&& <span className="se-mandatory pl-4">{"  "} Rule: Connexium VLANs can be configured only if VLANs are assigned in the trunk member list.</span>}
                          <div className="table-responsive mt-2">
                            <VlanTableHeading  headers = {fortiGateVlanHeaders}/>
                            <table className="table table-bordered">
                              <tbody>
                                {secureCommunicationData?.connexiumFortigateVlanConfigurations?.map(
                                  (data) => (
                                   <FortigateConnexiumVlanTable
                                      typeList={interfaceTypeListFortigateConexium}
                                      key={data.id}
                                      data={data}
                                      communicationType="connexiumFortigateVlanConfigurations"
                                      handleSelectMemberType={
                                        handleSelectMemberType
                                      }
                                      handleAccessEnable={handleAccessEnable}
                                      handleSelectAccessMember={
                                        handleSelectAccessMember
                                      }
                                      getHybridMembers={getHybridMembers}
                                      secureData={secureCommunicationData}
                                      dropdownValues={dropdownValues}
                                       hasConflicts = {hasConflicts}
                                      vlanConfigurationType={vlanConfiguration}
                                    />
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      </>
                    }
 
 
 
 
 
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                        {/* <se-button
                            option="flat"
                            color="primary"
                           
                          >
                            Save
                          </se-button> */}
                        {
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm se-btn-primary"
                            onClick={saveSecureCommunicationData}
                          >
                            <se-icon size="nano">action_save</se-icon>
                            <span>&nbsp;</span>Save
                          </button>
                        }
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                        <se-snackBar
                          id="custom-securepage"
                          type={snackBar.type}
                          message={snackBar.message}
                          icon="information_stroke"
                          duration="3000"
                        ></se-snackBar>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        ) : (
          <se-loading loading={loading}></se-loading>
        )}
      </div>
    </>
  );
};
 
export default withRouter(SecureArchitectureHook);